import React from 'react';
import { Link } from 'react-router-dom';
import defaultImage from '../others-profiles/default.webp';
import { getPrimaryUserImage } from '../../../utils/userImages';

const STATUS_BADGES = {
  pending: { label: 'Pending', className: 'bg-warning text-dark' },
  accepted: { label: 'Accepted', className: 'bg-success' },
  declined: { label: 'Declined', className: 'bg-secondary' },
  cancelled: { label: 'Withdrawn', className: 'bg-light text-dark border' },
};

const formatDateTime = (value) => {
  if (!value) return '';
  const date = new Date(String(value).replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const RequestCard = ({ item, highlighted, busyAction, onAccept, onDecline, onCancel, onStartChat }) => {
  const user = item.user || {};
  const isReceived = item.direction === 'received';
  const isPending = item.status === 'pending';
  const badge = STATUS_BADGES[item.status] || STATUS_BADGES.pending;
  const busy = Boolean(busyAction);
  const meta = [user.hs_id, user.age ? `${user.age} Yrs` : null, user.city || null].filter(Boolean).join(' · ');
  const displayName = user.name || user.hs_id || 'Member';

  return (
    <div
      id={`request-${item.request_id}`}
      className={`card request-card mb-3 ${highlighted ? 'request-card--highlight' : ''}`}
    >
      <div className="card-body d-flex gap-3">
        <img
          src={getPrimaryUserImage(user) || defaultImage}
          onError={(e) => { e.currentTarget.src = defaultImage; }}
          alt={displayName}
          className="request-card__photo"
        />
        <div className="flex-grow-1 request-card__body">
          {highlighted && isReceived && isPending && (
            <div className="request-card__hint rounded py-2 px-3 mb-2" role="status">
              Plan active? Tap <b>Accept request</b> below to connect and start chatting.
            </div>
          )}
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
            <div className="request-card__name">
              <h6 className="mb-0 text-capitalize">{displayName}</h6>
              {meta && <small className="text-muted">{meta}</small>}
            </div>
            <span className={`badge ${badge.className}`}>{badge.label}</span>
          </div>

          {item.message ? (
            <p className="request-card__message mb-2">{item.message}</p>
          ) : (
            <p className="text-muted fst-italic small mb-2">No message</p>
          )}

          <small className="text-muted d-block mb-2">
            {isReceived ? 'Received' : 'Sent'} {formatDateTime(item.created_at)}
          </small>

          <div className="request-card__actions">
            {isReceived && isPending && (
              <>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  disabled={busy}
                  onClick={() => onAccept(item)}
                >
                  {busyAction === 'accept' ? 'Accepting…' : 'Accept request'}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  disabled={busy}
                  onClick={() => onDecline(item)}
                >
                  {busyAction === 'decline' ? 'Declining…' : 'Decline'}
                </button>
              </>
            )}
            {!isReceived && isPending && (
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                disabled={busy}
                onClick={() => onCancel(item)}
              >
                {busyAction === 'cancel' ? 'Cancelling…' : 'Cancel request'}
              </button>
            )}
            {item.status === 'accepted' && (
              <button type="button" className="btn btn-danger btn-sm" onClick={() => onStartChat(user)}>
                Start chat
              </button>
            )}
            {user.user_id ? (
              <Link to={`/view-profile/${user.user_id}`} className="btn btn-link btn-sm request-card__profile-link">
                View profile
              </Link>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestCard;
